import { RefObject, useEffect } from 'react';
import { SearchSuggestItem } from '../../models/SearchSuggest';

interface useSearchBarKeyboardListenerProps {
  inputRef: RefObject<HTMLInputElement>;
  tagsSearchList: SearchSuggestItem[];
  onRemoveLastElement: () => void;
  typedSearchTerm: string;
}

const useSearchBarKeyboardListeners = ({
  inputRef,
  tagsSearchList,
  onRemoveLastElement,
  typedSearchTerm,
}: useSearchBarKeyboardListenerProps): void => {
  const handleKeyDown = (event) => {
    const { code } = event;
    const tagBox = document.getElementById('tag-box-parent');
    if (code === 'ArrowLeft' && inputRef.current === document.activeElement) {
      tagBox?.scrollBy({ left: -40 });
    } else if (code === 'ArrowRight' && inputRef.current === document.activeElement) {
      tagBox?.scrollBy({ left: 40 });
    } else if (code === 'Backspace' && inputRef.current === document.activeElement && !typedSearchTerm) {
      onRemoveLastElement();
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [tagsSearchList, typedSearchTerm]);
};

export default useSearchBarKeyboardListeners;
